import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { toast } from 'react-toastify';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { HiDownload } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';

const DashboardDownloadButton = ({ downloadRef, reportName = 'Report', disabled = false }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const captureCanvas = async () => {
    const doc = document.getElementById(downloadRef.current.id);
    const controls = doc.querySelector('.no-export');
    if (controls) controls.style.display = 'none';
    try {
      return await html2canvas(doc, { scale: 1 });
    } finally {
      if (controls) controls.style.display = '';
    }
  };

  const handleDownload = async (format) => {
    try {
      setIsLoading(true);
      const canvas = await captureCanvas();
      if (format === 'pdf') {
        const pdf = new jsPDF({ orientation: 'l', unit: 'pt', format: 'a4' });
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgData = canvas.toDataURL('image/png', 1.0);
        const imgProps = pdf.getImageProperties(imgData);
        const scaledHeight = Math.min((imgProps.height * pageWidth) / imgProps.width, pageHeight);
        pdf.addImage(imgData, 'png', 0, 0, pageWidth, scaledHeight);
        pdf.save(`${reportName}.pdf`);
      } else {
        const image = canvas
          .toDataURL(`image/${format}`, 1.0)
          .replace(`image/${format}`, 'image/octet-stream');
        const anchor = document.createElement('a');
        document.body.appendChild(anchor);
        anchor.setAttribute('download', `${reportName}.${format}`);
        anchor.setAttribute('href', image);
        anchor.click();
        anchor.parentNode.removeChild(anchor);
      }
    } catch (e) {
      toast.error(t('Something went wrong'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="secondary"
        className="custom-dashboard-button btn-export-download"
        disabled={disabled || isLoading}
      >
        <HiDownload fontSize={17} />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item onClick={() => handleDownload('pdf')}>{t('PDF')}</Dropdown.Item>
        <Dropdown.Item onClick={() => handleDownload('png')}>{t('PNG')}</Dropdown.Item>
        <Dropdown.Item onClick={() => handleDownload('jpeg')}>{t('JPEG')}</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DashboardDownloadButton;
